var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('StandardLayout',[(_vm.locationId)?_c('v-container',{directives:[{name:"hotkey",rawName:"v-hotkey",value:(_vm.keymap),expression:"keymap"}]},[_c('IndexPageContent'),_c('router-view')],1):_c('v-container',[_c('IndexPageEmptyState')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }